<template>
  <div>
    <div class="card" v-if="loading">
      <div class="card-body">
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div class="row" v-if="detailEdit">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <!-- Start Title -->
              <div class="d-flex">
                <div class="me-auto p-2">
                  <h4 class="card-title">
                    {{ detailEdit.opportunity_name.toUpperCase() }}
                  </h4>
                  <!-- Card Title -->
                  <h6 class="mb-0">
                    <span
                      v-for="(tag, tagI) in detailEdit.tags"
                      :key="tagI"
                      class="badge me-2"
                      :style="'background-color:' + tag.color"
                    >
                      {{ tag.name }}
                    </span>
                  </h6>
                </div>
                <div class="p-2">
                  <button
                    @click="
                            $bvModal.show('delete_bid_modal')
                          "
                    class="btn btn btn-danger waves-effect waves-light"
                  >
                    Delete
                  </button>

                  <b-modal
                        :id="'delete_bid_modal'"
                        hide-footer
                      >
                        <template #modal-header>
                          <h6 class="text-center">
                            DELETE {{ utility_state.label }} -
                            {{ legal_entity.label }}
                          </h6>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            :disabled="loadingAction"
                            @click="
                              $bvModal.hide('delete_bid_modal')
                            "
                          ></button>
                        </template>

                        <div class="modal-body">
                          <h3 class="text-center">Are you sure?</h3>
                          <h6 class="text-center">
                            You won't be able to revert this.
                          </h6>
                          <div class="d-grid gap-2 d-md-block text-center">
                            <form method="POST">
                              <input
                                type="hidden"
                                name="csrfmiddlewaretoken"
                                value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                              />
                              <button
                                class="btn btn-danger waves-effect waves-light"
                                type="button"
                                name="delete_bid"
                                value="11"
                                @click="deleteBid($route.params.bidId)"
                              >
                                Delete
                              </button>
                              <button
                                class="btn btn-light waves-effect waves-light"
                                type="button"
                                data-bs-dismiss="modal"
                                @click="
                                  $bvModal.hide('delete_bid_modal')
                                "
                              >
                                Cancel
                              </button>
                            </form>
                          </div>
                        </div>
                      </b-modal>
                </div>
              </div>
              <!-- End Title -->
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="Za8ypT7jnGDnyVI7EAMlVUGuxRsgSAeKNjfncNOPXvDo9FYF7hTxXyj67peyLJzd"
                />

                <div class="row">
                  <div class="col-lg-2">
                    <label for="supplier_id">Supplier*</label>
                    <select
                      name="supplier"
                      id="supplier_id"
                      class="form-select"
                      v-model.trim="$v.supplier.$model"
                      required=""
                    >
                      <option value="utility">Utility</option>
                      <option value="direct">Direct</option>
                    </select>
                    <div
                      v-if="submitted && !$v.supplier.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <label for="utility_state_id">Utility State*</label>
                    <v-select
                      v-model.trim="$v.utility_state.$model"
                      :options="utilityStateList"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.utility_state.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-8">
                    <label for="legal_entity_id">Legal Entity*</label>
                    <v-select
                      v-model.trim="$v.legal_entity.$model"
                      :options="legalEntityList"
                    ></v-select>
                    <div
                      v-if="submitted && !$v.legal_entity.required"
                      class="invalid-tooltip"
                    >
                      Select a valid Organization.
                    </div>
                    <p style="text-align: right">
                      <small
                        >The Organization do not appear at the list? Try to
                        create it clicking
                      </small>
                      <router-link :to="'/mpg/organizations/experian/search'"
                        ><small>HERE</small></router-link
                      >
                    </p>
                  </div>
                </div>

                <p></p>

                <p></p>
                <h5 class="font-size-14">Volumes</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-2">
                    <label for="annual_volume_id">Annual Volume</label>
                    <input
                      type="number"
                      name="annual_volume"
                      id="annual_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="annual_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="volume_unit_id">Unit</label>
                    <select
                      name="volume_unit"
                      id="volume_unit_id"
                      class="form-select"
                      v-model="volume_unit"
                    >
                      <option value="dth">DTH</option>

                      <option value="th">TH</option>
                    </select>
                  </div>
                </div>

                <p></p>

                <!-- <div class="row">
                  <div class="col-lg-2">
                    <label for="january_volume_id">January</label>
                    <input
                      type="number"
                      name="january_volume"
                      id="january_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="january_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="february_volume_id">February</label>
                    <input
                      type="number"
                      name="february_volume"
                      id="february_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="february_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="march_volume_id">March</label>
                    <input
                      type="number"
                      name="march_volume"
                      id="march_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="march_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="april_volume_id">April</label>
                    <input
                      type="number"
                      name="april_volume"
                      id="april_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="april_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="may_volume_id">May</label>
                    <input
                      type="number"
                      name="may_volume"
                      id="may_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="may_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="june_volume_id">June</label>
                    <input
                      type="number"
                      name="june_volume"
                      id="june_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="june_volume"
                    />
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-2">
                    <label for="july_volume_id">July</label>
                    <input
                      type="number"
                      name="july_volume"
                      id="july_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="july_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="august_volume_id">August</label>
                    <input
                      type="number"
                      name="august_volume"
                      id="august_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="august_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="september_volume_id">September</label>
                    <input
                      type="number"
                      name="september_volume"
                      id="september_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="september_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="october_volume_id">October</label>
                    <input
                      type="number"
                      name="october_volume"
                      id="october_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="october_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="november_volume_id">November</label>
                    <input
                      type="number"
                      name="november_volume"
                      id="november_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="november_volume"
                    />
                  </div>

                  <div class="col-lg-2">
                    <label for="december_volume_id">December</label>
                    <input
                      type="number"
                      name="december_volume"
                      id="december_volume_id"
                      class="form-control"
                      min="0.0"
                      step="any"
                      v-model="december_volume"
                    />
                  </div>
                </div>

                <p></p> -->
                <h5 class="font-size-14">Complementary Information</h5>
                <p></p>

                <div class="row">
                  <div class="col-lg-3">
                    <label for="pricing_type_id">Pricing Type</label>
                    <vue-tags-input
                      @focus="openDefaultPricing = true"
                      @blur="onBlurPricing"
                      v-model.trim="pricing_type"
                      :tags="pricing_type_tags"
                      :add-only-from-autocomplete="true"
                      :autocomplete-items="pricingTypeList"
                      :autocomplete-always-open="openDefaultPricing"
                      @tags-changed="(newTags) => (pricing_type_tags = newTags)"
                    />
                    <div
                      v-if="submitted && pricing_type_tags.length === 0"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label for="pricing_point_id">Pricing Point</label>
                    <select
                      name="pricing_point"
                      id="pricing_point_id"
                      class="form-select"
                      v-model.trim="pricing_point"
                    >
                      <option value="City Gate">City Gate</option>
                      <option value="Burner Tip">Burner Tip</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="swing_id">Swing</label>
                    <vue-tags-input
                      @focus="openDefaultSwing = true"
                      @blur="onBlurSwing"
                      v-model.trim="swing"
                      :tags="swing_tags"
                      :add-only-from-autocomplete="true"
                      :autocomplete-items="swingList"
                      :autocomplete-always-open="openDefaultSwing"
                      @tags-changed="(newTags) => (swing_tags = newTags)"
                    />
                    <div
                      v-if="submitted && swing_tags.length === 0"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label for="terms_id">Terms</label>
                    <vue-tags-input
                      @focus="openDefaultTerm = true"
                      @blur="onBlurTerms"
                      v-model.trim="terms"
                      :tags="terms_tags"
                      :add-only-from-autocomplete="true"
                      :autocomplete-items="termsList"
                      :autocomplete-always-open="openDefaultTerm"
                      @tags-changed="(newTags) => (terms_tags = newTags)"
                    />
                    <div
                      v-if="submitted && terms_tags.length === 0"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-3">
                    <label for="new_renewal_id">New/Renewal</label>
                    <select
                      name="new_renewal"
                      id="new_renewal_id"
                      class="form-select"
                      v-model.trim="new_renewal"
                    >
                      <option value="New">New</option>
                      <option value="Renewal">Renewal</option>
                    </select>
                  </div>

                  <div class="col-lg-3">
                    <label for="site_count_id">Site Count</label>
                    <input
                      type="number"
                      name="site_count"
                      id="site_count_id"
                      class="form-control"
                      min="0"
                      v-model="site_count"
                    />
                  </div>

                  <div class="col-lg-3">
                    <label for="meter_count_id">Meter Count</label>
                    <input
                      type="number"
                      name="meter_count"
                      id="meter_count_id"
                      class="form-control"
                      min="0"
                      v-model="meter_count"
                    />
                  </div>
                  <div class="col-lg-3">
                    <label for="earliest_date_id">Start Date</label>
                    <input
                      type="date"
                      name="start_date"
                      id="earliest_date_id"
                      class="form-control"
                      v-model="start_date"
                    />
                  </div>
                </div>

                <p></p>

                <div class="row">
                  <div class="col-lg-6">
                    <label for="index_name_id">Index Name</label>
                    <input
                      type="text"
                      name="index_name"
                      id="index_name_id"
                      class="form-control"
                      v-model="index_name"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label for="special_pricing_needs_id"
                      >Special Pricing Needs ID</label
                    >
                    <input
                      type="text"
                      name="special_pricing_needs"
                      id="special_pricing_needs_id"
                      class="form-control"
                      v-model="special_pricing_needs"
                    />
                  </div>
                </div>

                <p></p>

                <h5 class="font-size-14">Files</h5>
                <p></p>
                <div class="row">
                  <div class="col-lg-12">
                    <div class="drag-area">
                      <div>
                        <div
                          :class="['dropZone', dragging ? 'dropZone-over' : '']"
                          @dragenter="dragging = true"
                          @dragleave="dragging = false"
                        >
                          <div class="dropZone-info" @drag="onChange">
                            <span
                              style="
                                font-size: 21pt;
                                margin-bottom: 15px;
                                color: #bebebe;
                              "
                              class="fas fa-cloud-upload-alt dropZone-title"
                            ></span>
                            <span class="dropZone-title"
                              >Drag and drop files here</span
                            >
                            <span> Or </span>
                            <button
                              type="button"
                              class="
                                btn btn-primary btn-sm btn-task
                                mb-3
                                mt-3
                                removeFile
                              "
                              @click="fileInput.click()"
                            >
                              Browse files
                            </button>
                            <div class="dropZone-upload-limit-info">
                              <div>extension support: *</div>
                              <div>maximum file size: 5 MB</div>
                            </div>
                          </div>
                          <input
                            refs="fileInput"
                            type="file"
                            @change="onChange"
                            multiple
                          />
                        </div>
                      </div>
                    </div>

                    <template v-if="file">
                      <p></p>
                      <div
                        v-for="(fileData, index) in file"
                        :key="index"
                        class="file-list-item"
                      >
                        <a :href="fileData.file" target="_blank">
                          {{ fileData.name }}
                        </a>
                        <button
                              class="
                                btn btn-link
                                text-danger text-gradient
                                px-3
                                mb-0
                              "
                              :disabled="loadingAction"
                              type="button"
                          @click="deleteFile(fileData)"
                          ><i
                            class="far fa-trash-alt me-2"
                            aria-hidden="true"
                          ></i
                          >Delete</button
                        >
                      </div>
                    </template>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <template v-if="bidFiles">
                      <p v-if="!file"></p>
                      <div
                        v-for="(fileData, index) in bidFiles"
                        :key="index"
                        class="file-list-item"
                      >
                        <a :href="fileData.file" target="_blank">
                          {{ fileData.filename }}
                        </a>

                        <button
                              class="
                                btn btn-link
                                text-danger text-gradient
                                px-3
                                mb-0
                              "
                              :disabled="loadingAction"
                              type="button"
                          @click="deleteFileBid(fileData)"
                          ><i
                            class="far fa-trash-alt me-2"
                            aria-hidden="true"
                          ></i
                          >Delete</button
                        >
                      </div>
                    </template>
                  </div>
                </div>
                <p></p>
                <p></p>
                <!-- Start Button -->
                <div class="d-flex flex-wrap gap-2">
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="$router.go(-1)"
                  >
                    Cancel
                  </button>
                </div>
                <!-- End Button -->
              </form>
              <!-- End Form -->
            </div>
            <!-- End Card Body -->
          </div>
          <!-- End Card -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { opportunityService } from '../services/opportunities.service'
import { bidsService } from '../services/bids.service'
import VueTagsInput from '@johmun/vue-tags-input'
import { required } from 'vuelidate/lib/validators'
// import { router } from '../router'
import { utilService } from '../services/util.service'
import { organizationsService } from '@/services/organizations.service'
import { authenticationService } from '../services/authentication.service'

export default {
  name: 'OpportunitiesBid',
  components: { VueTagsInput },
  data () {
    return {
      error: '',
      autocompleteItems: [],
      supplier: '',
      volume_unit: '',
      annual_volume: null,
      january_volume: null,
      february_volume: null,
      march_volume: null,
      april_volume: null,
      may_volume: null,
      june_volume: null,
      july_volume: null,
      august_volume: null,
      september_volume: null,
      october_volume: null,
      november_volume: null,
      december_volume: null,
      terms: '',
      terms_tags: [],
      swing: '',
      swing_tags: [],
      pricing_type: '',
      pricing_type_tags: [],
      site_count: null,
      meter_count: null,
      start_date: '',
      special_pricing_needs: '',
      new_renewal: '',
      index_name: '',
      pricing_point: '',
      opportunity: null,
      utility_state: null,
      legal_entity: null,
      termsList: [],
      pricingTypeList: [],
      swingList: [],
      utilityStateList: [],
      legalEntityList: [],
      openDefaultPricing: false,
      openDefaultSwing: false,
      openDefaultTerm: false,
      loading: true,
      loadingAction: false,
      submittedTag: false,
      submitted: false,
      isEdit: false,
      detailEdit: null,
      file: '',
      bidFiles: [],
      dragging: false
    }
  },
  validations: {
    legal_entity: { required },
    supplier: { required },
    utility_state: { required },
    swing_tags: { required },
    terms_tags: { required },
    pricing_type_tags: { required }
  },
  computed: {
    // extension () {
    //   return this.file ? this.file.name.split('.').pop() : ''
    // }
  },
  created () {
    this.loading = true
    this.termsList = utilService.getListTerm()
    this.pricingTypeList = utilService.getListPricingType()
    this.swingList = utilService.getListSwing()
    if (this.$route.params.bidId && this.$route.params.bidId !== '') {
      this.isEdit = true
    }

    organizationsService
      .getData({
        q: '',
        ordering: '',
        limit: '9999999999',
        offset: 0,
        expands: ''
      })
      .then((rs) => {
        this.legalEntityList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id
          return e
        })
        utilService.getUtilityState().then((utilityStates) => {
          this.utilityStateList = utilityStates.results
            .filter((c) => c.status === 'active')
            .map((e) => {
              e.label = `${e.utility.name}, ${e.name}, ${e.state.acronym}`
              e.code = e.utility_state_id
              return e
            })
          this.utilityStateList = this.utilityStateList.sort((a, b) =>
            a.label.localeCompare(b.label)
          )
          bidsService.getFileFile(this.$route.params.bidId).then((files) => {
            this.bidFiles = files.results
          })
          opportunityService.getDataById(this.$route.params.id).then((opp) => {
            this.detailEdit = opp
          })
          if (this.isEdit) {
            bidsService
              .getDataById(this.$route.params.bidId)
              .then((bidData) => {
                this.supplier = bidData.supplier
                this.volume_unit = bidData.volume_unit
                this.annual_volume = bidData.annual_volume
                this.january_volume = bidData.january_volume
                this.february_volume = bidData.february_volume
                this.march_volume = bidData.march_volume
                this.april_volume = bidData.april_volume
                this.may_volume = bidData.may_volume
                this.june_volume = bidData.june_volume
                this.july_volume = bidData.july_volume
                this.august_volume = bidData.august_volume
                this.september_volume = bidData.september_volume
                this.october_volume = bidData.october_volume
                this.november_volume = bidData.november_volume
                this.december_volume = bidData.december_volume
                this.special_pricing_needs = bidData.special_pricing_needs
                this.new_renewal = bidData.new_renewal
                this.index_name = bidData.index_name
                this.pricing_point = bidData.pricing_point
                this.terms_tags = this.termsList.filter(
                  (e) => bidData.terms.indexOf(parseInt(e.id)) > -1
                )
                this.swing_tags = this.swingList.filter(
                  (e) => bidData.swing.indexOf(parseFloat(e.id)) > -1
                )
                this.pricing_type_tags = this.pricingTypeList.filter(
                  (e) => bidData.pricing_type.indexOf(e.id) > -1
                )
                this.site_count = bidData.site_count
                this.meter_count = bidData.meter_count
                this.start_date = bidData.start_date

                this.utility_state = this.utilityStateList.find(
                  (e) =>
                    e.utility_state_id ===
                    bidData.utility_state.utility_state_id
                )
                this.legal_entity = this.legalEntityList.find(
                  (e) =>
                    e.organization_id === bidData.legal_entity.organization_id
                )
                this.loading = false
              })
          } else {
            this.loading = false
          }
        })
      })
  },
  methods: {
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },
    createFile (files) {
      // if (!file.type.match('text.*')) {
      //   alert('please select txt file');
      //   this.dragging = false;
      //   return;
      // }

      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.file = [...this.file, ...files]
      console.log(this.file)
      this.dragging = false
    },
    deleteFile (fileData) {
      this.file = this.file.filter((e) => e.name !== fileData.name)
    },
    deleteFileBid (file) {
      this.loadingAction = true
      bidsService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.loadingAction = false
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.bidData = this.bidData.filter((e) => e.file_id !== file.file_id)
        })
        .catch(() => {
          this.loadingAction = false
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    },
    onBlurPricing () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.openDefaultPricing = false
        }, 500)
      })
    },
    onBlurSwing () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.openDefaultSwing = false
        }, 500)
      })
    },
    onBlurTerms () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.openDefaultTerm = false
        }, 500)
      })
    },
    onSubmit () {
      this.submitted = true

      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid || this.loadingAction) {
        return
      }
      //
      this.loadingAction = true
      const payload = {
        supplier: this.supplier,
        legal_entity: this.legal_entity.code,
        utility_state: this.utility_state.code,
        opportunity: this.$route.params.id,
        pricing_type: [],
        annual_volume: this.annual_volume,
        swing: [],
        terms: []
      }
      if (this.volume_unit && this.volume_unit !== '') {
        payload['volume_unit'] = this.volume_unit
      }
      if (this.january_volume && this.january_volume !== '') {
        payload['january_volume'] = this.january_volume
      }
      if (this.february_volume && this.february_volume !== '') {
        payload['february_volume'] = this.february_volume
      }
      if (this.march_volume && this.march_volume !== '') {
        payload['march_volume'] = this.march_volume
      }
      if (this.april_volume && this.april_volume !== '') {
        payload['april_volume'] = this.april_volume
      }
      if (this.may_volume && this.may_volume !== '') {
        payload['may_volume'] = this.may_volume
      }
      if (this.june_volume && this.june_volume !== '') {
        payload['june_volume'] = this.june_volume
      }

      if (this.july_volume && this.july_volume !== '') {
        payload['july_volume'] = this.july_volume
      }
      if (this.august_volume && this.august_volume !== '') {
        payload['august_volume'] = this.august_volume
      }
      if (this.september_volume && this.september_volume !== '') {
        payload['september_volume'] = this.september_volume
      }
      if (this.october_volume && this.october_volume !== '') {
        payload['october_volume'] = this.october_volume
      }
      if (this.november_volume && this.november_volume !== '') {
        payload['november_volume'] = this.november_volume
      }
      if (this.december_volume && this.december_volume !== '') {
        payload['december_volume'] = this.december_volume
      }
      if (this.terms_tags && this.terms_tags.length > 0) {
        payload['terms'] = this.terms_tags.map((e) => e.id)
      }

      if (this.swing_tags && this.swing_tags.length > 0) {
        payload['swing'] = this.swing_tags.map((e) => e.id)
      }
      if (this.pricing_type_tags && this.pricing_type_tags.length > 0) {
        payload['pricing_type'] = this.pricing_type_tags.map((e) => e.id)
      }
      if (this.site_count && this.site_count !== '') {
        payload['site_count'] = this.site_count
      }
      if (this.meter_count && this.meter_count !== '') {
        payload['meter_count'] = this.meter_count
      }
      if (this.start_date && this.start_date !== '') {
        payload['start_date'] = this.start_date
      }
      if (this.special_pricing_needs && this.special_pricing_needs !== '') {
        payload['special_pricing_needs'] = this.special_pricing_needs
      }
      if (this.new_renewal && this.new_renewal !== '') {
        payload['new_renewal'] = this.new_renewal
      }
      if (this.index_name && this.index_name !== '') {
        payload['index_name'] = this.index_name
      }
      if (this.pricing_point && this.pricing_point !== '') {
        payload['pricing_point'] = this.pricing_point
      }

      const type = authenticationService.currentContentTypeValue
      const contentType = type.find((e) => e.model === 'file').id
      if (this.isEdit) {
        bidsService.update(payload, this.$route.params.bidId).then(
          (rs) => {
            this.loadingAction = false

            if (this.file.length > 0) {
              for (let i = 0; i < this.file.length; i++) {
                let formData = new FormData()
                formData.append('file', this.file[i])
                formData.append('filename', this.file[i].name)
                formData.append('object_id', this.$route.params.bidId)
                formData.append('content_type', contentType)
                bidsService.uploadFile(formData).then(
                  (rs) => {},
                  (error) => {
                    this.$bvToast.toast('Error.', {
                      title: `Error. Cannot Upload File ${error}`,
                      variant: 'danger',
                      solid: true
                    })
                  }
                )
              }

              this.$nextTick(() => {
                this.$router.go(-1)
              })
            } else {
              this.$router.go(-1)
            }
          },
          (error) => {
            this.$bvToast.toast('Cannot update this bid.', {
              title: `Error`,
              variant: 'danger'
            })
            this.error = error
            this.loadingAction = false
          }
        )
      } else {
        bidsService.add(payload).then(
          (rs) => {
            if (this.file.length > 0) {
              for (let i = 0; i < this.file.length; i++) {
                let formData = new FormData()
                formData.append('file', this.file[i])
                formData.append('filename', this.file[i].name)
                formData.append('object_id', rs.bid_id)
                formData.append('content_type', contentType)
                bidsService.uploadFile(formData).then(
                  (rs) => {},
                  (error) => {
                    this.$bvToast.toast('Error.', {
                      title: `Error. Cannot Upload File ${error}`,
                      variant: 'danger',
                      solid: true
                    })
                  }
                )
              }

              this.$nextTick(() => {
                this.$router.go(-1)
              })
            } else {
              this.$nextTick(() => {
                this.$router.go(-1)
              })
            }
          },
          (error) => {
            this.$bvToast.toast('Cannot add this bid.', {
              title: `Error`,
              variant: 'danger'
            })
            this.error = error
            this.loadingAction = false
          }
        )
      }
    },
    deleteBid (id) {
      this.loadingAction = true
      bidsService.deleteDataById(id).then((rs) => {
        this.$router.go(-1)
      })
    }
  }
}
</script>

<style scoped>
.dropZone {
  width: 100%;
  height: 300px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px dashed #0060ae;
}

.dropZone:hover .dropZone-title {
  color: #0060ae;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #008dff1f;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}

.picker-input {
  position: relative;
  z-index: 98;
  width: 50px;
}
.picker-box {
  position: absolute;
  top: 47px;
  left: 1px;
  z-index: 99;
}
.picker-fade {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 97;
  left: 0;
  top: 0;
}

.form-control-color {
  padding: 0.47rem !important;
  height: 39px !important;
}

.file-list-item {
  margin-bottom: 7px;
  background: #eee;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/OpportunitiesBid.vue